import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import swal from 'sweetalert2'
import Preloader from '../../preloader/Preloader'
import $ from 'jquery'

//components
import { DataTableItem, UserRoute, BreadCrumb, Card } from 'src/components'

//services
import { getProductMix, deleteProductMix } from 'src/services'

function ProductMix() {
  const [loading, setLoading] = useState(true)
  const [productMixList, setProductMixList] = useState([])

  useEffect(() => {
    getProductMix()
      .then((res) => {
        if (res.data.status === 200) {
          setProductMixList(res.data.productmix)
          //console.log(productMixList)
        }
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
      .catch(() => {
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
  }, [])

  const deleteRecord = (e, id) => {
    e.preventDefault()

    const thisClicked = e.currentTarget

    swal
      .fire({
        title: 'Are you sure you want to proceed?',
        text: 'This will completely delete the Product Mix permanently',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'Cancel!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteProductMix(id)
            .then((res) => {
              if (res.data.status === 200) {
                swal.fire('Deleted!', res.data.message, 'success')
                thisClicked.closest('tr').remove()
              } else if (res.data.status === 404) {
                swal.fire('Error', res.data.message, 'error')
              }
            })
            .catch(() => {
              setTimeout(() => {
                $('#dataTable').DataTable({
                  scrollX: false,
                  pageLength: 100,
                })
              }, 10)
              setLoading(false)
            })
        } else if (result.isDenied) {
          swal.fire('Changes are not saved', '', 'info')
        }
      })
  }

  const renderRowActions = (item) => {
    return (
      <>
        <Link to={`/products/productmix/update/${item.id}`} className="btn btn-info me-2">
          Edit
        </Link>
        <button onClick={(e) => deleteRecord(e, item.id)} className="btn btn-danger">
          Delete
        </button>
      </>
    )
  }

  if (loading) {
    return <Preloader />
  }

  const transformedItems = productMixList.map((item) => {
    // Transform each item's 'product_mix_list' into the desired format
    const productsMixed = item.product_mix_list
      .map(
        (itemMix) =>
          `Product: ${itemMix.product.product_name}, Added Ratio: ${itemMix.contains_percentage}%`,
      )
      .join(' \n ') // Join all products into a single string

    return {
      ...item, // Keep the rest of the item's properties
      product_mix_code: productsMixed, // Add the new 'product_code' property
    }
  })

  //console.log(transformedItems)

  const columns = [
    { label: 'Product Mix Code', key: 'product_docket' },
    { label: 'Products Mixed', key: 'product_mix_code' },
    // ... other columns
  ]

  const title = 'Products Mix'

  const breadcrumb = [
    {
      title: title,
      name: 'Add' + title,
      subtitle: title,
      subtitleroute: '/products',
    },
  ]

  const buttonValues = [
    {
      title: 'Add ' + title,
      variants: 'btn btn-primary my-3 mr-2',
      routes: '/products/productmix/create',
    },
  ]

  const cardValues = [
    {
      title: title,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <UserRoute data={buttonValues} />

      <Card data={cardValues}>
        {
          <DataTableItem
            data={transformedItems}
            columns={columns}
            renderRowActions={renderRowActions}
          />
        }
      </Card>
    </div>
  )
}

export default ProductMix
